var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighHeel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10375 20.4518H5.65994V12.4791C5.65994 11.896 5.88313 11.3368 6.28039 10.9245C6.36747 10.8341 6.50865 10.8341 6.59573 10.9245L6.68845 11.0207C7.03603 11.3815 7.30322 11.8169 7.4712 12.2964L9.92146 19.2899C10.1772 20.0198 10.7524 20.5915 11.488 20.7334C15.3136 21.4711 19.5243 20.5203 21.6018 19.7912C21.8431 19.7065 22 19.4691 22 19.2047C22 18.9771 21.8825 18.767 21.6921 18.6541L18.2846 16.6331C17.1501 15.9603 15.866 15.6064 14.5594 15.6064C13.0006 15.6064 11.6586 14.4693 11.1322 12.9465C10.1545 10.1185 8.32055 6.25418 5.42104 3.2262C5.12601 2.9181 4.64759 2.9282 4.35165 3.23536L3.32565 4.30023C1.76945 5.59236 1.89914 8.06894 2.1585 9.14571C3.7147 10.7609 4.10375 16.8177 4.10375 20.4518Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighHeel);
export default __webpack_public_path__ + "static/media/high-heel.9d44688d4488be248fd011ebd44fddc7.svg";
export { ForwardRef as ReactComponent };